import { URL_TO_WIDGET, URL_VISITED } from '../config'

export function setVisitTag () {
  window.DFI_client.dataLayer = {}

  if (URL_TO_WIDGET.includes(URL_VISITED)) {
    if (window.innerWidth <= 768) {
      window.DFI_client.dataLayer.modal = 'widget-mobile'
    } else {
      window.DFI_client.dataLayer.modal = 'widget-desktop'
    }
  }
}
